export default function authContentTypeHeader (token) {
  if (token) {
    return { Authorization: 'Bearer ' + token, accept: 'application/json', 'Content-Type': 'application/json' }
  } else {
    return {}
  }
}
